import { trueFalseTemplate } from './gameTypes/trueFalse';
import { multipleChoiceTemplate } from './gameTypes/multipleChoice';
import { dragAndDropTemplate } from './gameTypes/dragAndDrop';
import { sortAndOrderTemplate } from './gameTypes/sortAndOrder';
import { fillInTheBlanksTemplate } from './gameTypes/fillInTheBlanks';
import { scenarioBasedTemplate } from './gameTypes/scenarioBased';
import { flashcardsTemplate } from './gameTypes/flashcards';

// Helper function to parse theme colors string into an object
export const parseThemeColors = (themeColors) => {
  const defaultColors = {
    primary: '#402034',
    secondary: '#4b5563',
    accent: '#F05A5B'
  };

  if (!themeColors) return defaultColors;

  try {
    const colors = {};
    const colorParts = themeColors.split(',').map(part => part.trim());
    
    colorParts.forEach(part => {
      if (part.includes('Primary Color:')) {
        colors.primary = part.split(':')[1].trim();
      } else if (part.includes('Secondary Color:')) {
        colors.secondary = part.split(':')[1].trim();
      } else if (part.includes('Accent Color:')) {
        colors.accent = part.split(':')[1].trim();
      }
    });

    return {
      primary: colors.primary || defaultColors.primary,
      secondary: colors.secondary || defaultColors.secondary,
      accent: colors.accent || defaultColors.accent
    };
  } catch (error) {
    console.error('Error parsing theme colors:', error);
    return defaultColors;
  }
};

export const gameTemplates = {
  "true-false": trueFalseTemplate,
  "drag-and-drop": dragAndDropTemplate,
  "sort-and-order": sortAndOrderTemplate,
  "fill-in-the-blanks": fillInTheBlanksTemplate,
  "scenario-based": scenarioBasedTemplate,
  "multiple-choice": multipleChoiceTemplate,
  "flashcards": flashcardsTemplate
};

export const getGameTemplate = (gameType, data) => {
  if (gameTemplates[gameType]) {
    return gameTemplates[gameType](data);
  }
  return null;
}; 